import React from "react";

import styles from "./ForgotPassword.module.scss";
import logo from "assets/img/compliancy-group-logo.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import Button from "components/Button/Button";
import { submitUserLoginFormAction, submitUserForgotPasswordAction } from "store/actions/Actions";

import WelcomePanel from "../components/WelcomePanel/WelcomePanel";
import FormElement from "components/FormElement/FormElement";
import InputAdornment from "components/InputAdornment/InputAdornment";

const ForgotPassword = props => {
    const handleForgot = (e) => {
        const email = document.getElementById('user-login').value;
        if (email) {
            props.submitUserForgotPasswordAction({ email });
        }
    }

    return (
        <WelcomePanel type="forgot">
            <div className={styles["login-panel-heading"]}>
                <img className={styles.logo} src={logo} alt="" />
            </div>

            <div className={styles["login-panel-content"]}>
                <p className={styles.welcome}>Enter your e-mail address!</p>
                <FormElement>
                    <InputAdornment iconStart="fal fa-at">
                        <input
                            type="text"
                            placeholder="E-mail"
                            name="user"
                            id="user-login"
                        />
                    </InputAdornment>
                </FormElement>
            </div>

            <div className={styles["login-panel-footer"]}>
                <Button text={"SEND EMAIL"} onClick={handleForgot} />
            </div>
        </WelcomePanel>
    );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    submitUserLoginFormAction,
    submitUserForgotPasswordAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPassword));
